import Route from '@ember/routing/route';

export default class RoombaSettingsRoute extends Route {}
